import { filesize } from 'filesize'

export const fileSize = (size: number): string => {
  return filesize(size, {
    spacer: '',
    base: 2,
    output: 'string',
  }) as string
}
